import gql from 'graphql-tag';

export default gql`
  mutation shipmentsUpdate($_id: ID!, $detail_from_tms: detail_from_tms_input) {
    shipmentsUpdate(_id: $_id, detail_from_tms: $detail_from_tms) {
      _id
    }
  }
`;
